import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { normalizeServerColor } from '../utils/serverColor';

interface ServerColorState {
  byServerId: Record<string, string>;
  setServerColor: (serverId: string, color: string | null) => void;
}

export const useServerColorStore = create<ServerColorState>()(
  persist(
    (set) => ({
      byServerId: {},
      setServerColor: (serverId, color) =>
        set((state) => {
          const normalizedServerId = (serverId || '').trim();
          if (!normalizedServerId) return state;

          const normalizedColor = normalizeServerColor(color);
          const next = { ...state.byServerId };
          if (normalizedColor) next[normalizedServerId] = normalizedColor;
          else delete next[normalizedServerId];

          return { byServerId: next };
        })
    }),
    {
      name: 'server-color-preferences-v1'
    }
  )
);
